import { Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/**
 * App-wide toast outlet. Mounted once at the router root. Position + behavior
 * are tuned for mobile (top-center, swipe-to-dismiss, stacked).
 */
export function ToastProvider() {
  return (
    <ToastContainer
      position="top-center"
      autoClose={4000}
      newestOnTop
      closeOnClick
      pauseOnFocusLoss
      draggable
      draggablePercent={40}
      theme="colored"
      limit={3}
      stacked
      transition={Slide}
    />
  );
}
